module.exports = __webpack_public_path__ + "img/written-answer-card.123b5eee.svg";